/**
 * ULID üretimi — sözleşme `Transaction.id` için zaman sıralı kimlik istiyor.
 * Kimliği arayüz üretir çünkü `NewTransaction` `id` alanını içerir.
 */

const ENCODING = "0123456789ABCDEFGHJKMNPQRSTVWXYZ"; // Crockford base32
const TIME_LEN = 10;
const RANDOM_LEN = 16;

function randomBytes(n: number): Uint8Array {
  const out = new Uint8Array(n);
  const c = globalThis.crypto;
  if (c && typeof c.getRandomValues === "function") {
    c.getRandomValues(out);
    return out;
  }
  // Kriptografik kaynak yoksa (çok eski ortam) yine de kimlik üretmeliyiz.
  for (let i = 0; i < n; i += 1) out[i] = Math.floor(Math.random() * 256);
  return out;
}

function encodeTime(now: number): string {
  let t = now;
  let out = "";
  for (let i = TIME_LEN - 1; i >= 0; i -= 1) {
    const mod = t % 32;
    out = ENCODING[mod] + out;
    t = (t - mod) / 32;
  }
  return out;
}

function encodeRandom(): string {
  const bytes = randomBytes(RANDOM_LEN);
  let out = "";
  for (let i = 0; i < RANDOM_LEN; i += 1) out += ENCODING[(bytes[i] ?? 0) % 32];
  return out;
}

export function ulid(now: number = Date.now()): string {
  return encodeTime(now) + encodeRandom();
}

/** Hesap / değerleme kimlikleri de aynı üreticiyi kullanır. */
export const newId = ulid;
